import { render, staticRenderFns } from "./NotifyPlanHolding.vue?vue&type=template&id=2d1be5d5&scoped=true&"
import script from "./NotifyPlanHolding.vue?vue&type=script&lang=ts&"
export * from "./NotifyPlanHolding.vue?vue&type=script&lang=ts&"
import style0 from "./NotifyPlanHolding.vue?vue&type=style&index=0&id=2d1be5d5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1be5d5",
  null
  
)

export default component.exports